query TripBreakdownSearchTraveler(
  $searchRequest: SearchRequestInput
  $first: Int
  $filter: TripBreakdownFilter
  $orderBy: [TripBreakdownsOrderBy!]
  $after: Cursor
  $isLinkSearch: Boolean
) {
  tripBreakdownSearch(
    searchRequest: $searchRequest
    first: $first
    filter: $filter
    orderBy: $orderBy
    after: $after
    isLinkSearch: $isLinkSearch
  ) {
    nodes {
      id
      _isCorporateTravelAuthorization
      businessUnitId
      _companionTicketUsed
      _companionAmountUsed
      _tripWarningInfo
      _travelPolicyDescription
      _primaryTravelerName
      tripLocator
      _rowTimestamp
      travelerReferenceName
      travelAuthorizationNumber
      comment
      corporateWorkgroupName
      travelAuthorizationDate
      _departmentName
      _isoCode
      airfareAmount
      budgetAmount
      accommodationAmount
      vehicleRentalAmount
      transportationAmount
      trainAmount
      otherAmount
      controlTotalAmount
      _isOverBudget
      airfareBudgetAmount
      _isAirfareOverBudget
      accommodationBudgetAmount
      _isAccommodationOverBudget
      vehicleRentalBudgetAmount
      _isVehicleRentalOverBudget
      transportationBudgetAmount
      _isTransportationOverBudget
      trainBudgetAmount
      _isTrainOverBudget
      incidentalAmount
      incidentalBudgetAmount
      _isIncidentalOverBudget
      _taStatusType
      _isAccommodationExist
      _isTrainExist
      _isVehicleRentalExist
      _isTransportationExist
      _isIncidentalExist
      _isAirfareExist
      _travelTags
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      travelAuthorization {
        id
        _rowTimestamp
        _isUpdatable
        _isDistributionUpdateAllowed
        bookingFee
      }
      tripPurpose
      _businessUnitName
      _baseIsoCode
      _baseCurrencyAmount
      _spotCurrencyAmount
      _createdDate
      _createdByUserName
    }
    aggregates {
      sum {
        airfareAmount
        accommodationAmount
        vehicleRentalAmount
        transportationAmount
        trainAmount
        otherAmount
        controlTotalAmount
        incidentalAmount
        controlTotalAmount
        _companionTicketUsed
        _companionAmountUsed
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
